/**
 * Utility functions for determining field types and deprecated field handling
 */

import TemplateFormFieldModel from '../models/templating/api/TemplateFormFieldModel';
import ApplicationContainer from '../state/containers/ApplicationContainer';
import AppliedApplicationTemplateModel from '../models/templating/api/AppliedApplicationTemplateModel';
import { FoodOrderingFeatureFlagId } from '../constants/featureFlagIds';

const SINGLE_DAY_TIME_RANGE_FIELD_ASSOCIATED_VARIABLES = [
    "{MONDAY}",
    "{TUESDAY}",
    "{WEDNESDAY}",
    "{THURSDAY}",
    "{FRIDAY}",
    "{SATURDAY}",
    "{SUNDAY}",
];

const SPECIAL_DATE_FIELD_ASSOCIATED_VARIABLE = "DISABLED_DAYS";

/**
 * Check if the current app is a Food Ordering module with the Food Ordering feature flag
 */
export const isFoodOrderingModuleWithFlag = (
    appContainer: ApplicationContainer,
    appliedAppTemplate?: AppliedApplicationTemplateModel
): boolean => {
    const currentApp = appContainer?.state?.currentApp;

    // Check if app has the Food Ordering feature flag
    const hasFoodOrderingFlag = currentApp?.featureFlags?.some(
        (flag) => flag.id === FoodOrderingFeatureFlagId
    );

    if (!hasFoodOrderingFlag) {
        return false;
    }

    return true;
};

/**
 * Check if a field is a deprecated SingleDayTimeRangeField
 * (used in Food Ordering apps for day-of-week variables)
 */
export const isDeprecatedSingleDayTimeRangeField = (
    field: TemplateFormFieldModel,
    appContainer: ApplicationContainer,
    appliedAppTemplate?: AppliedApplicationTemplateModel
): boolean => {
    if (!SINGLE_DAY_TIME_RANGE_FIELD_ASSOCIATED_VARIABLES.includes(field.associatedVariable)) {
        return false;
    }

    return isFoodOrderingModuleWithFlag(appContainer, appliedAppTemplate);
};

/**
 * Check if a field is a deprecated SpecialDateField
 * (used in Food Ordering apps for the DISABLED_DAYS variable)
 */
export const isDeprecatedSpecialDateField = (
    field: TemplateFormFieldModel,
    appContainer: ApplicationContainer,
    appliedAppTemplate?: AppliedApplicationTemplateModel
): boolean => {
    if (field.associatedVariable !== SPECIAL_DATE_FIELD_ASSOCIATED_VARIABLE) {
        return false;
    }

    return isFoodOrderingModuleWithFlag(appContainer, appliedAppTemplate);
};
